import type { IconData } from '@stacksjs/iconify-core'

export const deepfakeTechnology1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23.5 2.5A1.5 1.5 0 0 0 22 4v10.25h-3.275l-3.555-3.555a4.5 4.5 0 1 0-2.475 2.475l4.068 4.067A1.75 1.75 0 0 0 18 17.75h4v4.5H10.147a4.501 4.501 0 1 0 0 3.5H22v5.5h-5c-.464 0-.91.184-1.237.513l-4.068 4.067a4.5 4.5 0 1 0 2.475 2.475l3.555-3.555H22v10.117a1.5 1.5 0 0 0 1.5 1.5H32a1.5 1.5 0 0 0 1.5-1.5V41.11l2.918.493a4.5 4.5 0 0 0 5.233-4.06l.484-5.756a13.5 13.5 0 0 0 3.452-1.564c1.639-1.06 1.65-3.081.777-4.374l-3.919-5.8C41.705 10.234 33.506 2.5 23.5 2.5\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default deepfakeTechnology1Solid
